
const CancelButton = ({ name, styles, handleClose }) => {
    return (
        <button
            onClick={handleClose}
            type="button"
            className={`border border-green-700 text-green-700  rounded ${styles} p-3`}>
            {name}
        </button>
    )
}

export default CancelButton;